var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33333 6H12C12.7364 6 13.3333 6.59695 13.3333 7.33333V12C13.3333 12.7364 12.7364 13.3333 12 13.3333H7.33333C6.59695 13.3333 6 12.7364 6 12V7.33333C6 6.59695 6.59695 6 7.33333 6Z",
    strokeWidth: 1.26667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#181B23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.3335 9.9987H2.66683C2.31321 9.9987 1.97407 9.85822 1.72402 9.60817C1.47397 9.35812 1.3335 9.01899 1.3335 8.66536V2.66536C1.3335 2.31174 1.47397 1.9726 1.72402 1.72256C1.97407 1.47251 2.31321 1.33203 2.66683 1.33203H8.66683C9.02045 1.33203 9.35959 1.47251 9.60964 1.72256C9.85969 1.9726 10.0002 2.31174 10.0002 2.66536V3.33203",
    strokeWidth: 1.26667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#181B23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6b8e795d981481dd13f0df1fec18e22a.svg";
export { ForwardRef as ReactComponent };